const ASPECT_RATIO_TOLERANCE = 0.02;

export const readImageDimensions = (file) =>
    new Promise((resolve) => {
        const url = URL.createObjectURL(file);
        const image = new Image();
        image.onload = () => {
            URL.revokeObjectURL(url);
            resolve({
                width: image.naturalWidth,
                height: image.naturalHeight
            });
        };
        image.onerror = () => {
            URL.revokeObjectURL(url);
            resolve({ width: 0, height: 0 });
        };
        image.src = url;
    });

export const validateAspectRatio = async (file, { height, strict, width }) => {
    const recommended = { width, height };
    if (!strict) {
        return { valid: true, expectedRatio: null, recommended };
    }
    const dimensions = await readImageDimensions(file);
    const expectedRatio = width / height;
    // SVG u otros formatos sin dimensiones intrínsecas: no bloquear
    if (!dimensions.width || !dimensions.height) {
        return { valid: true, expectedRatio, recommended };
    }
    const actualRatio = dimensions.width / dimensions.height;
    const valid =
        Math.abs(actualRatio - expectedRatio) / expectedRatio <=
        ASPECT_RATIO_TOLERANCE;
    return { valid, expectedRatio, recommended };
};

export const aspectErrorMessage = ({ expectedRatio, recommended }) => {
    const dimensions = `${recommended.width} × ${recommended.height}`;
    if (expectedRatio === 1) {
        return `La imagen debe ser cuadrada. Tamaño recomendado: ${dimensions}.`;
    }
    return `La imagen debe tener la proporción de ${dimensions}. Tamaño recomendado: ${dimensions}.`;
};
